/** Apply layout classes to every pagination region. */
export function initPaginationStyling() {
  document.querySelectorAll('.p-pagination').forEach((container) => {
    const count = container.children.length;
    container.classList.toggle('is-pagination-active', count > 0);
    container.classList.toggle('is-button__grid', count >= 2);
  });
}
